import { QueryStringIntegerSchema } from 'notable-common';
import { z } from 'zod';
import { ScenarioEntitySchema } from './entity.js';
import { FingerprintOutputKindSchema } from '../fingerprint/outputKind.js';
/**
 * A UTC instant, the one shape the staff app's date filter produces, normalized the way joi
 * normalizes it so the value reaching fingerprint does not change when this schema takes over.
 */
const ScenarioQueryInstantSchema = z.iso
    .datetime()
    .transform((value) => new Date(value).toISOString());
/**
 * Every filter the scenario list offers. All optional: no filter is the full list, subject to the
 * organization scoping the controller applies on top for a non-admin user.
 */
export const ScenarioFindAllQuerySchema = z
    .object({
    name: z.string().min(1).optional(),
    nameSubstring: z.string().min(1).optional(),
    output: FingerprintOutputKindSchema.optional(),
    outputIncludes: z.string().min(1).optional(),
    providerId: z.uuid().optional(),
    practiceId: z.uuid().optional(),
    scenarioPostVisitId: z.uuid().optional(),
    populationId: z.uuid().optional(),
    limit: QueryStringIntegerSchema.optional(),
    page: QueryStringIntegerSchema.optional(),
    startTime: ScenarioQueryInstantSchema.optional(),
    organizationId: z.string().min(1).optional(),
    entity: ScenarioEntitySchema.optional(),
    isEnabled: z.stringbool({ truthy: ['true'], falsy: ['false'] }).optional(),
})
    .strict();
/** The typeahead behind every scenario picker: a name fragment, scoped to one organization. */
export const ScenarioFindAllBasicQuerySchema = z
    .object({
    organizationId: z.uuid().optional(),
    q: z.string().min(1).optional(),
    limit: QueryStringIntegerSchema.optional(),
})
    .strict();
//# sourceMappingURL=findAll.js.map